const setCustomPrototypes = () => {
	Date.prototype.isLeapYear = function () {
		const fullYear = this.getFullYear();

		if ((fullYear & 3) != 0) {
			return false;
		}

		return fullYear % 100 !== 0 || fullYear % 400 === 0;
	};

	Date.prototype.getDayOfYear = function () {
		const dayCount = [
			0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334,
		];
		const mn = this.getMonth();
		const dn = this.getDate();
		let dayOfYear = dayCount[mn] + dn;

		if (mn > 1 && this.isLeapYear()) {
			dayOfYear++;
		}

		return dayOfYear;
	};

	Element.prototype.trigger = function (event) {
		const createdEvent: any = document.createEvent('HTMLEvents');
		createdEvent.initEvent(event, false, true);

		this.dispatchEvent(createdEvent);
	};
};

export default setCustomPrototypes;
